/** Bugsnagログレベル */
export enum BugsnagSeverity {
  /** error */
  ERROR = "error",
  /** info */
  INFO = "info",
  /** warning */
  WARNING = "warning"
}
